<!-- When you click on this style of button, a drop-down option menu is displayed  -->
<script setup lang="ts">
    import '../../css/choice.css';
    import { computed } from "vue"
    import { bootstrapButtonClass, bootstrapMarginLeftClass, bootstrapMarginRightClass, BootstrapPaddingValue } from '../lib/StyleHelpers';
    import * as utils from '../lib/ChoiceUtils'
    import { DisplayStyle, ButtonDisplayStyle, ButtonDisplaySize, DropDownButtonIconType, ExtraButtonDisplayStyle } from "../Enums/UiEnums";
    import { hasSlot } from '../lib/VueHelpers'

    const props = withDefaults(defineProps<{
            buttonTitle?: string,
            showDownArrow?: boolean,
            displayStyle?: DisplayStyle | ButtonDisplayStyle | ExtraButtonDisplayStyle,
            size?: ButtonDisplaySize,
            hideIfNoOptions?: boolean,
            buttonIcon?: DropDownButtonIconType,
            otherIcon?: string,
            startingPadding?: BootstrapPaddingValue,    // Add padding to the starting of the icon
            endingPadding?: BootstrapPaddingValue,      // Add padding to the end of the icon
            disabled?: boolean
        }>(), {
            showDownArrow: true,
            displayStyle: DisplayStyle.Primary,
            size: ButtonDisplaySize.Default,
            hideIfNoOptions: false,
            buttonIcon: DropDownButtonIconType.Bolt,
            otherIcon: "",
            disabled: false,
            endingPadding: 1
    });

    const dropdownButtonId = `dropDownButton_${utils.randomId(6)}`;


    // Computed
    const buttonClass = computed(() => bootstrapButtonClass(props.displayStyle, props.size, true) ?? "");
    const nonSplitButtonClass = computed(() => [buttonClass?.value, toggleButtonIndicatorClass?.value, "dropdown-toggle-split", bootstrapMarginLeftClass(props.startingPadding), bootstrapMarginRightClass(props.endingPadding)]);
    const toggleButtonIndicatorClass = computed(() => props.showDownArrow ? " dropdown-toggle":"");
    const btnDropDownOnlyStyle = computed(() => (props.buttonIcon === DropDownButtonIconType.DropDownOnly || props.buttonIcon === DropDownButtonIconType.Other ? "line-height: .25; padding-left: 0; padding-right: 0;width: 15px;" : ""));
    const ulDropDownOnlyStyle = computed(() => (props.buttonIcon === DropDownButtonIconType.DropDownOnly || props.buttonIcon === DropDownButtonIconType.Other ? "padding-bottom: 0px; padding-top: 0px;" : ""));

    // Hide the button if hideIfNoOptions is true and the default slot is empty
    const showButton = computed(() => false === props.hideIfNoOptions || (true === props.hideIfNoOptions && !hasSlot()));

    const buttonIconClass = computed(() => {
        switch(props.buttonIcon)
        {
            case DropDownButtonIconType.Bolt:
                return "fa-solid fa-bolt-lightning";
                
            case DropDownButtonIconType.Gear:
                return "fa-solid fa-gear";

            case DropDownButtonIconType.Hamburger:
                return "fa-solid fa-bars";

            case DropDownButtonIconType.Spinner:
                return "spinner-border spinner-border-sm";     

            case DropDownButtonIconType.Other:
                return props.otherIcon + " label-isalus-small";

            case DropDownButtonIconType.DropDownOnly:
                return "";
 
            default:
                alert(`Unexpected button icon: ${props.buttonIcon}`);
                return "fa-solid fa-bolt-lightning";
        }
    });

</script>

<template>
    <!-- Default slot is empty so don't split the button -->
    <template v-if="showButton">
        <button type="button" 
                    :class="nonSplitButtonClass" 
                    :id="dropdownButtonId" 
                    :title="buttonTitle"
                    :style="btnDropDownOnlyStyle"
                    :disabled="props.disabled"
                    data-bs-toggle="dropdown" 
                    aria-expanded="false">
            <slot name="button" v-if="props.buttonIcon != DropDownButtonIconType.DropDownOnly">
                <i :class="buttonIconClass" aria-hidden="true" style="padding-right:0.5em"></i>
            </slot>
            <slot name="button" v-if="props.buttonIcon === DropDownButtonIconType.DropDownOnly" >
                <i  aria-hidden="true" style="display: none;"></i>
            </slot>                
        </button>
        <ul class="dropdown-menu" :aria-labelledby="dropdownButtonId" :style="ulDropDownOnlyStyle">
            <slot>
                <span class="text-danger">No dropdown items</span>
            </slot> 
        </ul>
    </template>

</template>